import { useEffect } from "react"
import ViewApplication from "pages/BaseApplication/ViewApplication"
import BaselDetails from "./BaselDetails"

const BaselConvention = props => {
  useEffect(() => {}, [])

  return (
    <>
      <ViewApplication
        attachments={props.appDetails.application_attachments}
        appDetails={props.appDetails}
        appDetailsComponent={<BaselDetails appDetails={props.appDetails} />}
      />
    </>
  )
}

export default BaselConvention
